import { track } from '@/utils/analytics';
import { IconType } from '@/ui-kit/components/icon/enums';
import BaseAction from './base.action';
import { ActionName } from '../enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import ToastService from '@/components/toast/toast-service';
import { getAction, ADD_FAVOURITES } from '@/store/listings/actions';
import { getAction as getUserAction, AUTHENTICATE } from '@/store/user/actions';

export default class AddToFavouritesAction extends BaseAction {
  name = ActionName.AddToFavourites;
  icon = IconType.Heart;
  colorSchema = StyleColorSchemeType.Danger;
  #analyticEvent = null;
  #store = null;

  constructor(config) {
    super(config);
    this.#analyticEvent = config.analyticEvent;
    this.#store = config.store;
  }

  get #isUserAuthenticated() {
    return this.#store.state.user.userData.isAuthenticated;
  }

  async execute(listing) {
    if (!this.#isUserAuthenticated) {
      await this.#store.dispatch(getUserAction(AUTHENTICATE));
    }

    const wasAdded = await this.#store.dispatch(getAction(ADD_FAVOURITES), listing);

    if (wasAdded) {
      ToastService.openPositive('Added To Favourites');
    }

    this.#trackExecution(listing);
    this.propagateResult(listing, wasAdded);
  }

  #trackExecution({ listingId, origin }) {
    track(this.#analyticEvent, { listingId, listingType: origin });
  }
}
